import { logToTealium } from 'src/ConsentManagement/Logging/TealiumEventService';
import { Tealium } from 'src/ConsentManagement/Tealium/TealiumTypes';
import * as AnalyticsService from '../AnalyticsService';

const isNullOrEmpty = (input: string): boolean => input == undefined || input == null || input == '';

const isAnalyticsDataPopulated = (consentInformation: { [name: string]: string }) =>
  !isNullOrEmpty(consentInformation.MemberId) && !isNullOrEmpty(consentInformation.VisitorId);

const getCookieValue = (cookieName: string) =>
  document.cookie.split(';').reduce(function (result, item) {
    if (item.indexOf(cookieName) >= 0) return item.split(cookieName)[1];
    return result;
  }, '');

export enum ConsentLevel {
  Shown = 'consent_shown',
  Partial = 'grant_partial_consent',
  Full = 'grant_full_consent',
  Decline = 'decline_consent',
}

export const logConsent = (
  consentType: ConsentLevel,
  options?: number[],
  catagories?: Tealium.Compliance.SelectedCategories,
): void => {
  const consentInformation: { [name: string]: string } = {
    MemberId: AnalyticsService.getUserId(),
    VisitorId: AnalyticsService.getVisitorId(),
    FallbackVisitorId: AnalyticsService.getFallbackVisitorId(),
    policy: 'gdpr',
    euconsent: getCookieValue('euconsent='),
    options: options?.length > 0 ? options?.join(',') : '',
    categories: catagories !== undefined ? JSON.stringify(catagories) : '',
  };

  return isAnalyticsDataPopulated(consentInformation)
    ? logToTealium(consentType, consentInformation)
    : retryGetConsentInformation(consentType, consentInformation);
};

const retryGetConsentInformation = (consentType: string, consentInformation: { [name: string]: string }) => {
  let retryInterval: any = null;
  const intervalInMs = 50;
  const maxTries = 10;
  let tries = 1;

  retryInterval = setInterval(() => {
    consentInformation.MemberId = AnalyticsService.getUserId();
    consentInformation.VisitorId = AnalyticsService.getVisitorId();
    consentInformation.FallbackVisitorId = AnalyticsService.getFallbackVisitorId();

    if (tries++ < maxTries && !isAnalyticsDataPopulated(consentInformation)) return;

    consentInformation.MemberId = isNullOrEmpty(consentInformation.MemberId)
      ? 'ERROR: Could Not Get Associated ID'
      : consentInformation.MemberId;

    consentInformation.VisitorId = isNullOrEmpty(consentInformation.VisitorId)
      ? 'ERROR: Could Not Get Associated ID'
      : consentInformation.VisitorId;

    consentInformation.FallbackVisitorId = isNullOrEmpty(consentInformation.FallbackVisitorId)
      ? 'ERROR: Could Not Get Associated ID'
      : consentInformation.FallbackVisitorId;

    logToTealium(consentType, consentInformation);
    clearInterval(retryInterval);
    retryInterval = null;
  }, intervalInMs);
};
